import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import logo from "@/assets/reelistiq-wordmark-white.svg";

export function NewFooterSection() {
  const { t, localizedPath } = useLanguage();

  return (
    <footer role="contentinfo" className="bg-[hsl(0,0%,4%)] text-[hsl(0,0%,55%)] border-t border-[hsl(0,0%,12%)] py-12 px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          {/* Left */}
          <div>
            <img src={logo} alt="reelistiq – Vertical Drama Agency" title="reelistiq Logo" width="120" height="20" className="h-5 mb-4 opacity-70" loading="lazy" />
            <p className="text-xs max-w-xs">{t("footer.tagline")}</p>
            <p className="text-xs mt-2">Kollwitzstraße 76 · 10435 Berlin</p>
            <a href="mailto:hello@reelistiq.com" className="text-xs hover:text-[hsl(40,33%,97%)] transition-colors">
              hello@reelistiq.com
            </a>
          </div>

          {/* Social */}
          <div className="flex items-center gap-6 text-xs uppercase tracking-wider">
            <a href="https://www.instagram.com/reelistiq/" target="_blank" rel="noopener noreferrer" title="reelistiq on Instagram" className="hover:text-[hsl(40,33%,97%)] transition-colors">Instagram</a>
            <a href="https://www.linkedin.com/company/reelistiq/" target="_blank" rel="noopener noreferrer" title="reelistiq on LinkedIn" className="hover:text-[hsl(40,33%,97%)] transition-colors">LinkedIn</a>
            <a href="https://www.tiktok.com/@reelistiq" target="_blank" rel="noopener noreferrer" title="reelistiq on TikTok" className="hover:text-[hsl(40,33%,97%)] transition-colors">TikTok</a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-[hsl(0,0%,12%)] flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs">
          <p>© {new Date().getFullYear()} reelistiq</p>
          <div className="flex gap-6">
             <Link to={localizedPath("/impressum")} className="hover:text-[hsl(40,33%,97%)] transition-colors">{t("footer.legal")}</Link>
            <Link to={localizedPath("/datenschutz")} className="hover:text-[hsl(40,33%,97%)] transition-colors">{t("footer.privacy")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
